import { Box, Skeleton, Typography } from '@mui/material';
import React from 'react';

import { Note } from '../types/notes.types';
import { NoteListItem } from './NoteListItem';

interface NotesListProps {
    notes: Note[];
    selectedNoteId: string | null;
    selectedNotes: string[];
    onSelectNote: (note: Note) => void;
    onToggleSelection: (noteId: string) => void;
    loading?: boolean;
}

export const NotesList: React.FC<NotesListProps> = ({
    notes,
    selectedNoteId,
    selectedNotes,
    onSelectNote,
    onToggleSelection,
    loading,
}) => {
    if (loading) {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, p: 1 }}>
                {[...Array(3)].map((_, index) => (
                    <Box
                        key={index}
                        sx={{
                            p: 2,
                            borderBottom: theme => `1px solid ${theme.palette.border.main}`,
                        }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                            <Skeleton
                                variant="rectangular"
                                width={18}
                                height={18}
                                sx={{
                                    borderRadius: 0.5,
                                    flexShrink: 0,
                                    mt: 0.5,
                                }}
                            />
                            <Box sx={{ flex: 1 }}>
                                <Skeleton variant="text" width="70%" height={20} sx={{ mb: 0.5 }} />
                                <Skeleton variant="text" width="50%" height={18} />
                            </Box>
                        </Box>
                    </Box>
                ))}
            </Box>
        );
    }

    if (notes.length === 0) {
        return (
            <Box
                sx={{
                    p: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                <Typography sx={{ color: theme => theme.palette.text.secondary, fontSize: 14, textAlign: 'center' }}>
                    Aucun commentaire trouve
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, pr: 2, pb: 1 }}>
            {notes.map((note) => (
                <NoteListItem
                    key={note._id}
                    note={note}
                    isSelected={selectedNoteId === note._id}
                    isChecked={selectedNotes.includes(note._id)}
                    onSelect={() => onSelectNote(note)}
                    onToggleCheck={() => onToggleSelection(note._id)}
                />
            ))}
        </Box>
    );
};
